module.exports = __webpack_public_path__ + "img/tag_15anos.a133c8f2.svg";